import React, { FC } from "react";
import classNames from "classnames";
import { Review as ReviewInterface } from "@app/components/base-page/models";

type Props = {
  data: ReviewInterface;
};

export const Review: FC<Props> = ({ data }) => (
  <div className="w-full">
    <p
      className={classNames(
        "text-medium mb-5",
        "lg:text-large lg:mb-10",
        "xl:text-xx-large xl:mb-15",
      )}
    >
      {data.review}
    </p>
    <div className="text-medium mb-5">★ ★ ★ ★ ★</div>
    <p className="text-regular">{data.author}</p>
  </div>
);
